<template>
  <div id="projects" class="dragHand">
    <div id="navigation">
      <canvas id="scene3D"></canvas>
      <footer id="footer" :class="isInNavigation ? 'ui' : 'ui hide'">
        <div>
          <Counter ref="counter" :currentProject="currentProject" />
          <TextTransition id="projectSub" :content="currentProject.subTitle" idName="projectSub" />
        </div>
        <button id="exploreButton" :class="'underLineW ' + (isInNavigation ? 'event' : 'noevent')" @click="exploreProject" :disabled="!isInNavigation">
          EXPLORE
          <div @click="exploreProject">
            <img :src="require('../assets/assets2D/arrow-right.png')">
          </div>
        </button>
      </footer>
      <NavigationState ref="navigationState" :class="isInNavigation ? 'ui' : 'ui hide'" :currentProject="currentProject" :projectCount="projects.length"/>
    </div>
    <Project
      v-if="!isInNavigation"
      ref="project"
      :currentProject="currentProject"
      :sizes="sizes"
      :horizontalPosition="horizontalPosition"
      @backToNavigation="backToNavigation"
    />
  </div>
</template>

<script>
import World from '../scripts3D/World.js'
import Loader from '../utils/Loader.js'
import Scroll from '../utils/Scroll.js'

import Project from '../components/Project.vue'
import Counter from '../components/Counter.vue'
import TextTransition from '../components/TextTransition.vue'
import NavigationState from '../components/NavigationState.vue'

export default {
  name: 'Projects',
  components: { Project, Counter, NavigationState, TextTransition },
  data() {
    return {
      projects: require('../assets/data.json'),
      currentProject: null,
      updateContent: null,
      project: null,
      isInNavigation: true,
      scroll: null,
      sizes: null,
      horizontalPosition: 0,
      world: null
    }
  },
  methods: {
    exploreProject(){
      this.isInNavigation = false

      this.$nextTick(() => {
        this.scroll.resize(this.sizes)
        this.scroll.scrollTo(this.sizes.width)

        setTimeout(() => {
          this.scroll.loop()
        }, 100)
      })
    },
    backToNavigation(){
      this.scroll.scrollTo(0)
    },
    updateDocumentTile(){
      document.title = `SI. /PROJECT - ${this.currentProject.id}`
    }
  },
  beforeMount(){
    this.currentProject = this.projects[0]
  },
  mounted(){
    const local = this
    
    // Set Projects ID's
    for(let i = 0; i < this.projects.length; i++){
      this.projects[i]['id'] = ('0' + (i + 1)).slice(-2)
    }

    // Ini
    const loader = new Loader()
    loader.open()

    this.world = new World()
    this.world.updateCanvas()
    
    // Scrolling
    const callBackToNavigation = function(){
      local.isInNavigation = true
    }
    const setHorizontalPosition = function(position){
      local.horizontalPosition = position
    }

    this.scroll = new Scroll({
      container: document.getElementById('projects'),
      callBackToNavigation: callBackToNavigation,
      setHorizontalPosition: setHorizontalPosition,
      world: this.world
    })

    // ============= //
    // 3D Navigation //
    // ============= //
    this.project = this.world.setupProject(this.projects)

    this.project.camera.position.y = 1
    this.project.cameraDestination = 1
    setTimeout(() => {
      this.project.cameraDestination = 0
    }, 400)

    let lastID = -1
    function refreshCurrentProject(){
      const newID = local.project.getId()
      if(newID != lastID){
        local.currentProject = local.projects[newID]
        lastID = newID
        local.updateDocumentTile()
      }
    }    
    
    const canvas = document.getElementById('scene3D')

    // Wheel
    canvas.addEventListener('wheel', event => {
      if(this.isInNavigation){
        this.project.drag(-event.deltaY, true)
        this.project.stop(true)
        refreshCurrentProject()
      }
    })

    // Mouse
    canvas.addEventListener('mousedown', event => {
      if(this.isInNavigation){
        this.project.start(event)
      }
    })
    canvas.addEventListener('mouseup', () => {
      if(this.isInNavigation){
        this.project.stop(false)
      }
    })
    canvas.addEventListener('mouseleave', () => {
      if(this.isInNavigation){
        this.project.stop(false)
      }
    })
    canvas.addEventListener('mousemove', event => {
      if(this.isInNavigation){
        this.project.drag(event.clientY, false)
        refreshCurrentProject()
      }
    })

    // Touch
    canvas.addEventListener('touchstart', event => {
      if(this.isInNavigation){
        this.project.start(event['changedTouches'][0])
      }
    }) 
    canvas.addEventListener('touchend', () => {
      if(this.isInNavigation){
        this.project.stop(false)
      }
    })
    canvas.addEventListener('touchmove', event => {
      if(this.isInNavigation){
        this.project.drag(event['changedTouches'][0].clientY, false)
        refreshCurrentProject()
      }
    })

    function resize(sizes){
      local.sizes = sizes
      local.sizes.landscape = sizes.width > sizes.height

      local.$refs.navigationState.resize()

      if(!local.isInNavigation){
        local.scroll.resize(sizes)
        local.$refs.project.setSizes()
      }
    }

    this.project.uiResizeFunction = resize

    this.$nextTick(() => {
      this.world.updateSizes()
      refreshCurrentProject()
    })
  },
  unmounted(){
    this.scroll.animatedStack = []
  }
}
</script>

<style scoped>
#scene3D
{
  z-index: 1;
  height: 100vh;
  width: 100vw;
}
#projects
{
  overflow: hidden;
  z-index: 0;
  width: 100vw;
  /* height: 100%; */

  display: flex;
  flex-direction: row;
}
#navigation
{
  display: grid;
  background-color: #111111;
  color: #f5f5f5;
}
#scene3D,
#arrowBody
{
  grid-column: 1;
  grid-row: 1;
}
/* EXPLORATION */
#footer
{
  position: fixed;
  bottom: 0;

  z-index: 2;
  width: 100vw;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;

  pointer-events: none;
}
#footer p
{
  margin: 0;
}
#exploreButton
{
  display: flex;
  width: min-content;
  height: min-content;
  justify-content: flex-end;
  padding: 0;

  font-size: 1.5vh;

  cursor: pointer;

  background-color: transparent;
  color: #f5f5f5;
}
#exploreButton div
{
  margin-left: 1vh;
  height: 1.5vh;
  width: 1.5vh;
}
#exploreButton div img
{
  height: 100%;
  width: 100%;
  object-fit: contain;
}
/* Hide ui */
.ui
{
  transition: opacity 500ms ease-out;
}
.hide
{
  opacity: 0;
  pointer-events: none;
}
#projectSub
{
  font-size: 2vh;
  transition: clip-path 300ms;
}
.event
{
  pointer-events: all;
}
.noevent
{
  pointer-events: none;
}
@media (orientation: landscape) {
  #footer
  {
    padding: 3vh;
  }
}
@media (orientation: portrait) {
  #footer
  {
    padding: 1.5vh;
  }
}
</style>